import React from 'react';
import styled from 'styled-components';
import './Projects.css';

import BeeBallonImage from '../assets/BeeBalloonGamePC.png';
import SchmupImage from '../assets/SCHMUPPhone.png';
import MinesweeperImage from '../assets/MinesweeperPC.png';
import QuoteImage from '../assets/QuoteGenPC.png';
import MaskPC from '../assets/BeeBalloonGamePC.png'; // Add your mask images here
import MaskPhone from '../assets/SCHMUPPhone.png'; // Add your mask images here

const projects = [
  // {
  //   name: 'Home Library Database',
  //   description: 'A comprehensive database to manage your home library.',
  //   tools: 'Java, JavaFX, Scene Builder, SQL, MySQL',
  //   image: 'path/to/home-library-database.jpg',
  //   mask: MaskPC,
  //   size: { width: '550px', height: '350px' },
  //   link: 'https://github.com/stella-craig/Simple-University-Library-System-GUI',
  //   external: true,
  // },
  // {
  //   name: 'Brain Game',
  //   description: 'A fun and challenging brain game to test your cognitive skills.',
  //   tools: 'Unity, C#',
  //   image: 'path/to/brain-game.jpg',
  //   mask: MaskPC,
  //   size: { width: '550px', height: '350px' },
  //   link: 'https://github.com/stella-craig/Brain-Game',
  //   external: true,
  // },
  // {
  //   name: 'Reel Life',
  //   description: 'An immersive fishing simulation game.',
  //   tools: 'Godot, GDScript',
  //   image: 'path/to/reel-life.jpg',
  //   mask: MaskPC,
  //   size: { width: '550px', height: '350px' },
  //   link: 'https://github.com/stella-craig/TigerHacks23',
  //   external: true,
  // },
  {
    name: 'Quote Generator Website',
    description: 'A website that generates random quotes from a database and allows users to add their own.',
    tools: 'Angular, NodeJS, Express.js, MongoDB, HTML, CSS, JavaScript',
    image: QuoteImage,
    mask: MaskPC,
    size: { width: '550px', height: '350px' },
    link: 'https://github.com/pkanGitHub/quote-generator',
    external: true,
  },
  {
    name: 'Space SCHMUP',
    description: 'A space-themed shoot \'em up game developed in Unity, where the player focuses on shooting enemies while dodging their attacks.',
    tools: 'Unity, C#',
    image: SchmupImage,
    mask: MaskPhone,
    size: { width: '300px', height: '350px' },
    link: 'https://github.com/stella-craig/Space-SHMUP/tree/main',
    external: true,
  },
  {
    name: 'Bee Balloon Game',
    description: 'A cognitive training game designed to improve reaction time, ' +
      'hand-eye coordination, spatial perception, and attention through gameplay. Inspired by Cognifit’s "Bee Balloon" brain game.',
    tools: 'Unity, C#',
    image: BeeBallonImage,
    mask: MaskPC,
    size: { width: '550px', height: '350px' },
    link: 'https://github.com/stella-craig/Bee-Balloon-Game',
    external: true,
  },
  {
    name: 'Minesweeper in C',
    description: 'This program is a recreation of the classic Minesweeper game, ' + 
      'designed to run in the terminal. It is written in C and developed by members ' + 
      'of the Intro to CS Special Interest Group through the Mizzou Computing Association, ' + 
      'a group dedicated to teaching computer science fundamentals to college freshmen, ' + 
      'led by Stella Craig and Andrew Klusmeyer.',
    tools: 'C',
    image: MinesweeperImage,
    mask: MaskPC,
    size: { width: '550px', height: '350px' },
    link: 'https://github.com/stella-craig/Intro-to-CS-Minesweeper',
    external: true,
  },
];

const Projects = () => {
  return (
    <section id="projects" className="projects-section">
      <ProjectTitle>My Projects</ProjectTitle>
      <ProjectList>
        {projects.map((project, index) => (
          <ProjectItem key={index}>
            <ComputerIcon mask={project.mask} size={project.size}>
              <img src={project.image} alt={project.name} />
            </ComputerIcon>
            <ProjectDetails>
              <h3>{project.name}</h3>
              <p>{project.description}</p>
              <p><strong>Tools & Languages:</strong> {project.tools}</p>
              <Button
                href={project.link}
                target={project.external ? '_blank' : '_self'}
                rel={project.external ? 'noopener noreferrer' : ''}
              >
                GitHub Repository
              </Button>
            </ProjectDetails>
          </ProjectItem>
        ))}
      </ProjectList>
    </section>
  );
};

const ProjectTitle = styled.h2`
  font-size: 4.5rem;
  margin-bottom: 10px;
  text-align: center;
  color: white;
  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const ProjectList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
`;

const ProjectItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center; /* Center the computer icon and project details */
  gap: 100px;
  padding: 0px;
  background-color: rgba(182, 182, 182, 0); /* Set background to transparent */
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 70%;
  align-self: center; /* Center the project items */
  transition: transform 0.3s ease; /* Add transition for smooth scaling */
  &:hover {
    transform: scale(1.1); /* Scale up by 10% on hover */
  }
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    gap: 20px;
  }
`;

const ComputerIcon = styled.div`
  width: ${props => props.size.width};
  height: ${props => props.size.height};
  background-color: rgba(143, 143, 143, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; /* Hide overflowing image */
  mask-image: url(${props => props.mask}); /* Use the mask image */
  mask-size: cover;
  mask-repeat: no-repeat;
  mask-position: center;
  img {
    width: 95%;
    height: auto;
    filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.74)); /* Add glow effect */
  }
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

const ProjectDetails = styled.div`
  background-color: rgb(230, 230, 230);
  padding: 15px;
  display: flex;
  border-radius: 10px;
  flex-direction: column;
  align-items: center; /* Center the information */
  text-align: center; /* Align text to the center */
  gap: 15px;
  width: 500px; /* Set fixed width */
  h3 {
    margin: 0;
    font-size: 1.5rem;
    color: black;
  }
  p {
    margin: 0;
    font-size: 1rem;
    color: #666;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Button = styled.a`
  width: 150px; /* Set fixed width */
  height: 40px; /* Set fixed height */
  background-color:rgb(143, 97, 251);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  text-align: center;
  line-height: 40px; /* Center text vertically */
  text-decoration: none;
  transition: background-color 0.3s ease;
  &:hover {
    background-color:rgb(130, 33, 241);
  }
`;

export default Projects;
